import { Alert, CircularProgress, Typography } from "@mui/material";

import { userFacingErrorMessage } from "@/shared/http";

import styles from "./ConnectionStatus.module.css";
import { type SlackConnectStatus } from "./useConnectSlackPopup";

interface ConnectionStatusProps {
  status: SlackConnectStatus;
  onDismiss: () => void;
}

/** The in-flight half of the connect flow: waiting on the popup, or why it did not finish. */
export function ConnectionStatus({ status, onDismiss }: ConnectionStatusProps) {
  if (status.phase === "waiting") {
    return (
      <div className={styles.waitingRow}>
        <CircularProgress size={20} />
        <Typography variant="body2">
          Waiting for Slack — finish the install in the popup window.
        </Typography>
      </div>
    );
  }

  if (status.phase === "abandoned") {
    return (
      <Alert severity="info" onClose={onDismiss}>
        The Slack window closed before the install finished, so nothing was
        connected. Select Connect to Slack to try again.
      </Alert>
    );
  }

  if (status.phase === "failed") {
    return (
      <Alert severity="error" onClose={onDismiss}>
        {status.reason === "popup" ? (
          <>Connecting Slack failed. {status.message}</>
        ) : (
          <>
            Could not start the Slack connection:{" "}
            {userFacingErrorMessage(status.error)}
          </>
        )}
      </Alert>
    );
  }

  return null;
}
